import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "@fontsource/noto-serif-bengali/bengali-400.css";
import "@fontsource/noto-serif-bengali/bengali-600.css";
import "./styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { apiUrl } from "./app/api-url";
import { createAdminApp } from "./app/create-app";
import { applyTheme, watchSystemTheme } from "./app/theme";

applyTheme();
watchSystemTheme();

const { App } = await createAdminApp({
  baseUrl: apiUrl(),
  validateResponses: import.meta.env.DEV,
});

const root = document.getElementById("root");
if (root === null) throw new Error("#root is missing from index.html");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
